import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import { Box } from "@mui/system";
import "../../styles/deviceStyle.css";
import { fetchRolesEndPoint } from "../../configuration";
import { getRandomUUID } from "../../Token";
import RolesTable from "../../global/components/Tables/RolesTable";
import { useSelector,useDispatch } from "react-redux";
import {fetchRequest} from "../../store/actions/roles"
import CreateRole from "./CreateRole";

const Role = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [roleList, setRoleList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedRule, setSelectedRule] = useState();
  const [showDeleteRule, setShowDeleteRule] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isbulkPopupVisible, setIsBulkPopupVisible] = useState(false);

  useEffect(() => {
    setPageLoading(false);
  }, []);

  useEffect(() => {
    setTableLoading(true);
    setRoleList([]);
    // fetchRoles();
    dispatch(fetchRequest());
  }, [user?.accountId]);
  const closebulkPopup = () => {
    setIsBulkPopupVisible(false);
  };
  const handleUserCreatedAdd = () => {
    setIsBulkPopupVisible(false);
    //  fetchRoles();
    dispatch(fetchRequest());
  };
  const fetchRoles = async () => {
    try {
      let activeSession = sessionStorage.getItem("activeSession");
      if(activeSession){
        activeSession = JSON.parse(activeSession);
      }
      const response = await fetch(fetchRolesEndPoint(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        method: "POST",
        body: JSON.stringify({
          accountName: sessionStorage.getItem("accountId"),
          currentrole: activeSession?.role?.name,
          filter: { $sort: [{ field: "name", order: "asc" }] },
        }),
      });
      const data = await response.json();
      let roles = [];
      if (user.role.name !== "SUPER_ADMIN") {
        roles = data.filter((d) => d.name !== "SUPER_ADMIN");
      } else {
        roles = data;
      }
      if (roles) {
        setRoleList(data);
      }
    } catch (error) {
      return error;
    }
  };
  const createRule = () => {
    setIsBulkPopupVisible(true)
  };

  return (
    <div style={{ minHeight: "65vh", margin: "0 auto" }}>
      <Box sx={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center", // Ensure vertical alignment
          }}
        >
          <h2
            className="page-common-heading_tittle"
          >
            Roles
          </h2>
          <div style={{ alignContent: "end" }}>
            {user?.role?.permissions?.roles?.create ? (
              <Button style={{
                backgroundColor: "black",
                color: "white",
                fontSize: "16px",
                lineHeight: '20px',
                letterSpacing: '0.5px',
                fontWeight: 700,
              }} size="large" shape="round" use="primary" onClick={createRule}>
                Add role
              </Button>
            ) : null}
          </div>
        </div>
      </Box>
      <RolesTable
        roleLists={roleList}
        permissions={user?.role?.permissions}
        isEditable={user?.role?.permissions?.roles?.edit}
        isCreateUser={user?.role?.permissions?.users?.create}
        userRoleName={user?.role?.name}
        pagination={{
          position: ["bottomRight"],
        }}
        setShowDeleteRule={setShowDeleteRule}
        setSelectedRule={setSelectedRule}
        tableLoading={tableLoading}
        tableTitle="Active rules"
      />
      {isbulkPopupVisible && <CreateRole visible={isbulkPopupVisible} closePopup={closebulkPopup} state={null} onUserCreated={handleUserCreatedAdd} />}
    </div>
  );
};

export default Role;
